import { CHCMedicareLookupTool } from './medicare-lookup-tool.component.js';
export { CHCMedicareLookupTool };

customElements.define('chcapp-medicare-lookup-tool', CHCMedicareLookupTool);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-medicare-lookup-tool': CHCMedicareLookupTool;
  }
}
